export default "__VITE_ASSET__CnJpeWbH__"